import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import { mergeDeepRight } from 'ramda';
import { useIntl } from "gatsby-plugin-intl";

import { renderWhenTrue } from '../../utils/rendering';

ReactModal.setAppElement('body');

import { customStyles, CloseButton, ModalContent, CloseText, CloseIcon, ButtonWrapper } from './modal.styles';
import { useBreakpointsContext } from '../../store/BreakpointsContext';

export const Modal = ({ className, children, onRequestClose, styles = {}, ...props }) => {
  const { isDesktop } = useBreakpointsContext();
  const intl = useIntl();
  const mergedStyles = useMemo(() => {
    return mergeDeepRight(customStyles(isDesktop), styles);
  }, [styles]);

  const renderCloseButton = renderWhenTrue(() => (
    <CloseButton onClick={onRequestClose}>
      <CloseText>{intl.formatMessage({id:'Close'})}</CloseText>
      <CloseIcon width={21} height={21} />
    </CloseButton>
  ));

  return (
    <>
      <ReactModal style={mergedStyles} onRequestClose={onRequestClose} {...props}>
        <ButtonWrapper onClick={onRequestClose}>{renderCloseButton(props.isOpen)}</ButtonWrapper>
        <ModalContent className={className}>{children}</ModalContent>
      </ReactModal>
    </>
  );
};

Modal.propTypes = {
  children: PropTypes.any,
  styles: PropTypes.object,
  onRequestClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};
